<template>
  <basic-container v-loading="pageLoading">
    <!-- 列表 -->
    <avue-form
      ref="searchForm"
      v-model="searchForm"
      :option="searchFromOption"
      @reset-change="searchClear"
    >
      <template slot-scope="" slot="timeRange">
        <el-date-picker
          v-model="searchForm.timeRange"
          :clearable="false"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </template>
      <template slot="warehouseId">
        <el-select v-model="searchForm.warehouseId" placeholder="请选择仓库">
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.status == 0"
          >
          </el-option>
        </el-select>
      </template>

      <template slot-scope="" slot="requisitionUser">
        <el-select
          v-model="searchForm.requisitionUser"
          filterable
          remote
          placeholder="请输入申请人"
          :remote-method="remoteMethod"
          :loading="requisitionUserLoading"
        >
          <el-option
            v-for="item in requisitionUserList"
            :key="item.id"
            :label="item.realNameAndPhone"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>

      <template slot="menuForm">
        <el-button size="small" type="primary" @click="searchSubmit()">
          搜索
        </el-button>
        <el-button size="small" @click="searchClear()">重置</el-button>
        <div style="display: inline-block; margin: 0 20px 0 40px">汇总金额</div>
        <!-- <div style="display:inline-block;margin:0 20px;border:1px solid #333;height:32px;line-height:32px">123</div> -->
        
         <moneyInput v-model="sumData"  disabled  style= "display: inline-block; width: 150px"  /> 
      </template>
    </avue-form>
    <avue-crud
      :option="crudOption"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      @size-change="sizeChange"
      @current-change="currentChange"
      @search-change="searchChange"
    >
    <template slot-scope="scope" slot="requisitionAmount">
      <div class="money"><span>{{tool.money_format_allowvoid(scope.row.requisitionAmount)  }}</span></div>
    </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          @click="openDialog(scope.row, 'view')"
        >
          查看
        </el-button>
        <el-button
          type="text"
          size="small"
          @click="openDialog(scope.row, 'out')"
          v-if="
            scope.row.requisitionStatus == 3 || scope.row.requisitionStatus == 5
          "
        >
          出库
        </el-button>
      </template>
    </avue-crud>
    <!-- 新增弹窗 -->
    <el-dialog
      :title="mode === 'view' ? '查看' : '出库'"
      :visible.sync="addDialogVisible"
      append-to-body
      width="80%"
      @close="addDialogColse"
    >
      <div v-if="addDialogVisible">
        <avue-form ref="addForm" v-model="addForm" :option="addFormOption">
        </avue-form>
        <!--  csColumns  csNumKey  csPriceKey 都有默认值,可以不传-->
        <ConsumableSelector
          ref="cs"
          :columns="csColumns"
          :numberKey="csNumKey"
          :priceKey="csPriceKey"
          :data.sync="csData"
          :projectId="searchForm.projectId"
          @loadData="loadData"
          @loadPrice="loadPrice"
          :editable="false"
          :numberMode="mode == 'view' ? 'normal' : 'input'"
          :priceMode="mode == 'view' ? 'normal' : 'dynamic'"
          :showSum="true"
        />
        <div style="display: flex; justify-content: center; margin-top: 30px">
          <el-button
            v-if="mode == 'out'"
            type="primary"
            size="small"
            @click="outbound()"
            style="margin-right: 20px"
            >出库</el-button
          >
          <el-button
            v-if="
              mode == 'view' &&
              (this.addForm.requisitionStatus == 3 ||
                this.addForm.requisitionStatus == 5)
            "
            type="primary"
            size="small"
            @click="openCloseDialog"
            style="margin-right: 20px"
            >关单</el-button
          >
          <el-button size="small" @click="addDialogVisible = false"
            >取消</el-button
          >
          <el-dialog
            title="领用单关闭"
            :visible.sync="closeDialogVisible"
            width="50%"
            :before-close="handleClose"
            append-to-body
          >
            <el-form ref="form" label-width="100px">
              <el-form-item label="关单备注">
                <el-input v-model="closeRemark" type="textarea"></el-input>
              </el-form-item>
            </el-form>
            <div
              style="display: flex; justify-content: center; margin-top: 30px"
            >
              <el-button size="small" type="primary" @click="close">
                关 单
              </el-button>
              <el-button size="small" @click="closeDialogVisible = false"
                >取 消</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  getProjectList,
  getWarehouseList,
  getDict,
  getBusinessNo,
  consumableList,
} from "@/api/crmedical/warehouse/index.js";
import {
  getPriceSum,
  warehouseRequisitionPage,
  getProjectUserList,
  treeByProjectDeptId,
  warehouseRequisitionDetail,
  getConsumableListByRequisitionOutboundId,
  consumableCalculate,
  outboundSave,
  closeTheSingle,
} from "@/api/crmedical/requisition/index.js";
import ConsumableSelector from "@/components/consumable-selector/index";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  components: { ConsumableSelector },
  computed: {
    ...mapGetters(["userInfo"]),
    searchFromOption() {
      return {
        size: "small",
        submitBtn: false,
        emptyBtn: false,
        menuSpan: 8,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            span: 6,
            clearable: false,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.projectList,
            rules: [{ required: true, message: "请选择项目" }],
          },
          {
            label: "仓库名称",
            prop: "warehouseId",
            type: "select",
            span: 6,
            clearable: false,
            formslot: true,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.warehouseList,
            rules: [{ required: true, message: "请选择仓库" }],
          },
          {
            label: "申请人",
            prop: "requisitionUser",
            formslot: true,
            labelslot: true,
            errorslot: true,
            span: 6,
          },
          {
            label: "状态",
            prop: "requisitionStatus",
            type: "select",
            span: 6,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicData: this.requisition_outbound_status,
          },
          {
            label: "申请时间",
            prop: "timeRange",
            formslot: true,
            labelslot: true,
            errorslot: true,
            span: 8,
          },
          {
            label: "领用单号",
            prop: "requisitionNo",
            span: 6,
          },
        ],
      };
    },
    addFormOption() {
      return {
        size: "small",
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            span: 8,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.projectList,
            disabled: true,
          },
          {
            label: "仓库名称",
            prop: "warehouseId",
            type: "select",
            span: 8,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.warehouseList,
            disabled: true,
          },
          {
            label: "领用科室",
            prop: "requisitionDept",
            type: "tree",
            clearable: false,
            editDisplay: false,
            addDisplay: false,
            disabled: true,
            dicUrl: "api/v4ward/dept/tree",
            span: 8,
            props: { label: "title", value: "key" },
            rules: [
              {
                required: true,
                message: "请选择所属机构",
                trigger: "blur",
              },
            ],
          },
          {
            label: "出库单号",
            prop: "outboundNo",
            span: 8,
            disabled: true,
            display: this.mode == "out",
          },
          {
            label: "领用单号",
            prop: "requisitionNo",
            span: 8,
            disabled: true,
            display: this.mode == "view",
          },
          {
            label: "申请人",
            prop: "requisitionUserName",
            span: 8,
            disabled: true,
          },
          // {
          //   label: "出库人",
          //   prop: "tempOutBounduser",
          //   span: 6,
          //   disabled: true,
          //   display: this.mode == "out",
          // },
          // {
          //   label: "出库时间",
          //   prop: "tempOutBoundTime",
          //   span: 12,
          //   type: "date",
          //   disabled: true,
          //   display: this.mode == "out",
          // },
          {
            label: this.mode == "view" ? "领用备注" : "出库备注",
            prop: "remark",
            span: 24,
            maxlength: 300,
            disabled: this.mode === "view",
          },
        ],
      };
    },
    crudOption() {
      return {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        index: true,
        indexLabel: "序号",
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            clearable: false,
            span: 6,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.projectList,
          },
          {
            label: "领用单号",
            prop: "requisitionNo",
          },
          {
            label: "仓库名称",
            prop: "warehouseId",
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.warehouseList,
          },

          // {
          //   label: "领用科室",
          //   prop: "requisitionDept",
          //   type: "select",
          //   clearable: false,
          //   span: 6,
          //   props: {
          //     label: "title",
          //     value: "id",
          //   },
          //   rules: [{ required: true, message: "" }],
          //   dicData: this.deptList,
          // },
          {
            label: "领用科室",
            prop: "requisitionDept",
            type: "tree",
            editDisplay: false,
            addDisplay: false,
            dicUrl: "api/v4ward/dept/tree",
            props: { label: "title", value: "key" },
            rules: [
              {
                required: true,
                message: "请选择所属机构",
                trigger: "blur",
              },
            ],
          },
          {
            label: "申请人",
            prop: "userName",
            // type: "select",
            clearable: false,
            span: 6,
            // props: {
            //   label: "realNameAndPhone",
            //   value: "id",
            // },
            // rules: [{ required: true, message: "" }],
            // dicData: this.inboundStatusList,
          },
          {
            label: "申请时间",
            prop: "requisitionTime",
            span: 6,
          },
          {
            label: "总金额",
            prop: "requisitionAmount",
            span: 6,
            slot:true
          },
          {
            label: "状态",
            prop: "requisitionStatus",
            span: 6,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicData: this.requisition_outbound_status,
          },
        ],
      };
    },
  },
  data() {
    return {
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        layout: "total, sizes, prev, pager, next",
      },
      sumData: "",
      pageLoading: false,
      projectList: [],
      warehouseList: [],
      realNameAndPhone: false,
      requisitionUserList: [],
      requisition_outbound_status: [],
      deptList: [],
      projectUserList: [],
      mode: "", //out-出库,view-查看
      searchForm: {
        projectId: "",
        warehouseId: "",
        requisitionUser: "",
        requisitionStatus: "",
        timeRange: [],
        timeStart: "",
        timeEnd: "",
        requisitionNo: "",
      },
      addForm: {
        projectId: "", //项目id
        warehouseId: "", //仓库id
        outboundNo: "", //出库单号
        requisitionDept: "", //领用科室id
        requisitionDeptName: "", //领用科室名字
        requisitionUser: "", //申请人id
        requisitionUserName: "", //申请人名字
        tempOutBounduser: "", //临时展示出库人-后台不接
        tempOutBoundTime: "", //临时展示出库时间-后台不接
        remark: "",
      },
      addDialogVisible: false,
      closeDialogVisible: false,
      closeRemark: "",
      data: [], //入库单列表
      csData: [],
      csNumKey: "inputNum",
      csColumns: [
        { label: "序号", prop: "", type: "index", width: 50 },
        { label: "物品", prop: "name" },
        { label: "编号", prop: "code" },
        { label: "分类", prop: "typeName" },
        { label: "单位", prop: "measuringUnitName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
        { label: "生产商", prop: "manufacturer" },
        { label: "出库单价", prop: "price" },
        { label: "库存数量", prop: "stockNum", maxCheck: true },
        { label: "已出库数量", prop: "outboundNum" },
        {
          label: "申请数量",
          prop: "inboundNum",
          maxCheck: true,
        },
        { label: "出库数量", prop: "inputNum", ignoreZero: true },
        { label: "出库金额", prop: "rowSum" },
        {
          label: "剩余数量",
          prop: "surplus",
          maxCheck: true,
          hide: true,
        },
      ],
    };
  },
  watch: {
    "searchForm.projectId"(val, oldVal) {
      if (val) {
        this.searchForm.requisitionUser = "";
        const params = {
          projectId: this.searchForm.projectId,
        };
        //项目下仓库列表
        this.pageLoading = true;
        getWarehouseList(params)
          .then(({ data }) => {
            this.pageLoading = false;
            this.warehouseList = data;
            this.searchForm.warehouseId = this.warehouseList[0]
              ? this.warehouseList[0].id
              : "";
          })
          .catch((err) => {
            this.pageLoading = false;
            console.log("err==>", err);
          });
        //获取项目
        // treeByProjectDeptId(params).then(({ data }) => {
        //   const list = [];
        //   function searchChildren(data) {
        //     data.forEach((ele) => {
        //       list.push(ele);
        //       if (ele.children && ele.children.length > 0) {
        //         searchChildren(ele.children);
        //       }
        //     });
        //   }
        //   searchChildren(data);
        //   this.deptList = list;
        // });
      }
    },
    "addForm.projectId"(val, oldVal) {
      console.log("val==>", val);
      if (val && oldVal) {
        this.csData = [];
        getWarehouseList({
          projectId: this.addForm.projectId,
        }).then(({ data }) => {
          this.warehouseList = data;
          this.addForm.warehouseId = this.warehouseList[0]
            ? this.warehouseList[0].id
            : "";
        });
      }
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    //人员搜索
    remoteMethod(val) {
      if (!val) return;
      const params = {
        projectId: this.searchForm.projectId,
        realNameAndPhone: val,
      };
      this.requisitionUserLoading = true;
      getProjectUserList(params).then((res) => {
        this.requisitionUserLoading = false;
        console.log("res==>", res);
        this.requisitionUserList = res.data;
      });
    },
    openCloseDialog() {
      this.closeRemark = "";
      this.closeDialogVisible = true;
    },
    close() {
      // this.$confirm("是否提交", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      this.pageLoading = true;
      closeTheSingle({ id: this.addForm.id, remark: this.closeRemark }).then(
        (res) => {
          this.pageLoading = false;
          this.$message.success(res.msg);
          this.addDialogVisible = false;
          this.closeDialogVisible = false;
          this.loadList();
        }
      );
      // })
      // .catch(() => {
      //   this.pageLoading = false;
      //   this.$message({
      //     type: "info",
      //     message: "已取消",
      //   });
      // });
    },
    addDialogColse() {
      this.addForm.remark = "";
    },
    //领用出库
    async openDialog(row, type) {
      console.log("row==>", row);
      this.pageLoading = true;
      try {
        this.mode = type;
        let no = await getBusinessNo({ businessType: 2 });
        let res = await warehouseRequisitionDetail({ id: row.id });
        this.addForm = res.data;
        this.addForm.requisitionUserName = row.userName;
        this.addForm.outboundNo = no.data;
        this.addForm.tempOutBounduser = this.userInfo.nick_name;
        this.addForm.tempOutBoundTime = new Date();
        if (this.mode == "out") {
          this.addForm.remark = "";
        }
        let res2 = await getConsumableListByRequisitionOutboundId({
          requisitionId: row.id,
        });
        res2.data.forEach((ele) => {
          ele.outboundNum = ele.outboundNum > 0 ? ele.outboundNum : 0;
          ele.surplus = ele.inboundNum - ele.outboundNum;
          ele.inputNum = 0;
        });
        this.csData = res2.data;
        console.log("res2==>", res2);
        console.log("this.addForm==>", this.addForm);
      } catch (err) {
        console.log("err==>", err);
      }
      this.pageLoading = false;
      this.addDialogVisible = true;
    },
    searchClear() {
      //planA
      this.searchForm.requisitionUser = "";
      this.searchForm.requisitionStatus = "";
      this.searchForm.timeRange = [];
      this.searchForm.timeStart = "";
      this.searchForm.timeEnd = "";
      this.searchForm.requisitionNo = "";
      this.loadList();
      //planB
      // this.searchForm = {
      //   projectId: this.projectList[0] ? this.projectList[0].id : "",
      //   requisitionUser: "",
      //   requisitionStatus: "",
      //   timeRange: [],
      //   timeStart: "",
      //   timeEnd: "",
      //   requisitionNo: "",
      // };
      // getWarehouseList({
      //   projectId: this.searchForm.projectId,
      // }).then(({ data }) => {
      //   this.warehouseList = data;
      //   this.searchForm.warehouseId = this.warehouseList[0]
      //     ? this.warehouseList[0].id
      //     : "";
      //   this.loadList();
      // });
    },
    searchSubmit() {
      this.loadSumPrice();
      this.loadList();
    },
    outbound() {
      let emptyFlag = false;
      this.csData.forEach((ele) => {
        if (ele.inputNum > 0) {
          emptyFlag = true;
        }
        ele.id = "";
      });
      if (!emptyFlag) {
        this.$message.error("请至少输入一个出库货品的数量");
        return;
      }
      this.addForm.requisitionConsumableVOList = this.csData;
      console.log("出库提交数据==>", this.addForm);
      let vali = this.$refs.cs.validate();
      if (vali) {
        this.$confirm("是否提交", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.pageLoading = true;
            outboundSave(this.addForm).then((res) => {
              this.pageLoading = false;
              this.$message.success(res.msg);
              this.addDialogVisible = false;
              this.loadList();
            });
          })
          .catch(() => {
            this.pageLoading = false;
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    loadData(query, resolve) {
      query.name = query.text;
      const params = { ...query, projectId: this.searchForm.projectId };
      consumableList(params).then((res) => {
        res.data.records.forEach((element) => {
          element.id = "";
        });
        resolve(res.data);
      });
    },
    loadPrice(query, resolve) {
      //consumableId number
      const params = {
        ...query,
        warehouseId: this.addForm.warehouseId,
      };
      consumableCalculate(params).then((res) => {
        console.log("res consumableCalculate==>", res);
        resolve(res.data);
      });
    },
    async fetchData() {
      this.pageLoading = true;
      try {
        //projectList
        const resProjectList = await getProjectList();
        this.projectList = resProjectList.data;
        this.searchForm.projectId = this.projectList[0]
          ? this.projectList[0].id
          : "";
        //warehouseList
        const resWarehouseList = await getWarehouseList({
          projectId: this.searchForm.projectId,
        });
        this.warehouseList = resWarehouseList.data;
        this.searchForm.warehouseId = this.warehouseList[0]
          ? this.warehouseList[0].id
          : "";
        console.log("this.warehouseList==>", this.warehouseList);

        //type && status
        const dicts = await Promise.all([
          getDict({ code: "requisition_outbound_status" }),
        ]);
        this.requisition_outbound_status = dicts[0].data;
        console.log(
          "this.requisition_outbound_status==>",
          this.requisition_outbound_status
        );
        // this.searchForm.requisitionStatus = this.requisition_outbound_status[0]
        //   ? this.requisition_outbound_status[0].dictKey
        //   : "";
        //load list
        this.loadList();
      } catch (err) {
        console.log("err==>", err);
      }
      this.pageLoading = false;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      console.log("this.page==>", this.page);
      this.loadList();
    },
    currentChange(current) {
      this.page.current = current;
      this.loadList();
      console.log("this.page==>", this.page);
    },
    loadList() {
      this.formatTimes();
      this.pageLoading = true;
      const params = {
        projectId: this.searchForm.projectId,
        warehouseId: this.searchForm.warehouseId,
        requisitionUser: this.searchForm.requisitionUser,
        requisitionStatus: this.searchForm.requisitionStatus,
        timeStart: this.searchForm.timeStart,
        timeEnd: this.searchForm.timeEnd,
        requisitionNo: this.searchForm.requisitionNo,
        size: this.page.pageSize,
        currnet: this.page.currentPage,
      };
      warehouseRequisitionPage(params)
        .then((res) => {
          this.pageLoading = false;
          res.data.records.forEach((ele) => {
            ele.requisitionStatus += "";
            ele.requisitionTime = dayjs(ele.requisitionTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          });
          this.data = res.data.records;
          this.page.currentPage = res.data.current;
          // this.page.pageSize = res.data.pageSize;
          this.page.total = res.data.total;
          this.loadSumPrice();
        })
        .catch((err) => {
          this.pageLoading = false;
        });
    },
    loadSumPrice() {
      this.formatTimes();
      const params = {
        projectId: this.searchForm.projectId,
        warehouseId: this.searchForm.warehouseId,
        requisitionUser: this.searchForm.requisitionUser,
        requisitionStatus: this.searchForm.requisitionStatus,
        timeStart: this.searchForm.timeStart,
        timeEnd: this.searchForm.timeEnd,
        requisitionNo: this.searchForm.requisitionNo,
      };
      getPriceSum(params).then((res) => {
        console.log("res loadSumPrice==>", res);
        this.sumData = res.data;
      });
    },
    //格式化出库时间
    formatTimes() {
      let timeRange = this.searchForm.timeRange;
      if (timeRange && timeRange.length > 0) {
        this.searchForm.timeStart = dayjs(timeRange[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        this.searchForm.timeEnd = dayjs(timeRange[0]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
  .money{
  text-align: right;
}
</style>